import React from "react";
import { CopyableCodeLine } from "onboarding/components/NumberedStep";
import { INSTALLER_URL_BASE } from "onboarding/constants";
import { track } from "utils/track";
import EnvironmentSelector from "../../components/EnvironmentSelector";
import TokenSelector from "../../components/TokenSelector";

const INSTALLER_URL = `${INSTALLER_URL_BASE}/windows-solarwinds-snap-agent/solarwinds-snap-agent.msi`;

export default props => {
  const environmentSelect = {
    title: "Select Environment",
    content: <EnvironmentSelector />,
  };

  const tokenSelect = {
    title: "Select API Token",
    content: <TokenSelector />,
  };

  let steps = [
    {
      title: "Download the Windows Host Agent installer:",
      content: (
        <p onClick={_ => track("Clicked Windows installer URL")}>
          <a href={INSTALLER_URL}>{INSTALLER_URL}</a>
        </p>
      ),
    },
    {
      title: "Run the installer and provide this API token when requested:",
      content: (
        <div onClick={_ => track("Copied Windows API token")}>
          <CopyableCodeLine>{props.agentRecorderToken}</CopyableCodeLine>
        </div>
      ),
    },
  ];

  if (props.onboardingState.showModal) {
    return steps;
  } else if (props.environmentsWithTokenCount === 0) {
    steps.splice(1, 0, tokenSelect);
  } else {
    steps.splice(1, 0, environmentSelect, tokenSelect);
  }

  return steps;
};
